// Settings utility to read from localStorage
export interface AppSettings {
  companyName: string
  email: string
  phone: string
  address: string
  currency: string
  taxRate: string
  orderCutoffTime: string
  deliveryStartTime: string
  deliveryEndTime: string
  enableNotifications: boolean
  enableEmailAlerts: boolean
  autoAcceptOrders: boolean
  requireOrderConfirmation: boolean
}

const DEFAULT_SETTINGS: AppSettings = {
  companyName: 'Criket',
  email: 'admin@criket.com',
  phone: '809-555-1234',
  address: 'Santo Domingo, República Dominicana',
  currency: 'RD$',
  taxRate: '18',
  orderCutoffTime: '23:00', // 11 PM default
  deliveryStartTime: '12:00',
  deliveryEndTime: '14:00',
  enableNotifications: true,
  enableEmailAlerts: true,
  autoAcceptOrders: false,
  requireOrderConfirmation: true,
}

export function getSettings(): AppSettings {
  const saved = localStorage.getItem('criket_settings')
  return saved ? JSON.parse(saved) : DEFAULT_SETTINGS
}

export function saveSettings(settings: AppSettings): void {
  localStorage.setItem('criket_settings', JSON.stringify(settings))
}
